import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { log as pilog } from "common/utils";
import { useWebSocketsHook } from "./WebSocketsHook";
const WebSocketsContext = /*#__PURE__*/createContext({});
export const WebSocketsContextProvider = ({
  children,
  eventProcessorHook,
  shouldConnect = true
}) => {
  const log = pilog.getLogger("WebSocketContextProvider");
  const hook = useWebSocketsHook(eventProcessorHook);
  React.useEffect(() => {
    log.debug(`Ready to connect ${shouldConnect}`);
    if (shouldConnect) {
      log.debug("Should only be called once");
      hook.connectToWebSocket();
    }
  }, [shouldConnect]);

  // once this context is destroyed, disconnect from WS
  React.useEffect(() => {
    return () => {
      hook.disconnectFromWebSocket();
    };
  }, []);

  /* if the limitless-root is remove from the page or the window closes, disconnect from web sockets
   *  added for when test-rig kill the node or when the browser is closed.
   */
  React.useEffect(() => {
    let observer;
    if (process.env.REACT_APP_TYPE !== "mobile") {
      window.addEventListener("onbeforeunload", hook.disconnectFromWebSocket);
      const elemToObserve = document.getElementById("limitless-root");
      if (elemToObserve) {
        try {
          observer = new MutationObserver(() => {
            if (!document.getElementById("limitless-root")) {
              hook.disconnectFromWebSocket();
            }
          });
          observer.observe(elemToObserve.parentNode, {
            childList: true,
            subtree: false
          });
        } catch (error) {
          log.warn("Failed to disconnect from web sockets when node was removed from DOM %o", error);
        }
      }
    }
    return () => {
      if (process.env.REACT_APP_TYPE !== "mobile") {
        window.removeEventListener("onbeforeunload", hook.disconnectFromWebSocket);
        if (observer) {
          observer.disconnect();
        }
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(WebSocketsContext.Provider, {
    value: hook
  }, children);
};
export const useWebSockets = () => {
  return useContext(WebSocketsContext);
};
WebSocketsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  eventProcessorHook: PropTypes.func.isRequired,
  shouldConnect: PropTypes.bool
};